import { useState } from 'react';

import axiosPrivate from 'config/axiosPrivate';

export const useRequestIncreaseAnalysis = ({
  t,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
}) => {
  const [showCreditButton, setShowCreditButton] = useState(false);

  const requestIncreaseAnalysis = () => {
    setErrorSuccess(false);

    axiosPrivate
      .put('/user/requestIncreaseAnalysis')
      .then((res) => {
        setShowCreditButton(false);
        setErrorSuccessMsg(`${t("La demande d'ajout de crédit est envoyée")}!`);
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch((e) => {
        setErrorSuccessMsg(`Oups...! ${t("Une erreur s'est produite")}.`);
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return {
    requestIncreaseAnalysis,
    showCreditButton,
    setShowCreditButton,
  };
};
